import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { appConfig } from '../../appConfig';
import IMG_LOADING from '../../assets/images/loading.gif';

const unSupportedStates = {
  CO: 'Colorado',
  CT: 'Connecticut',
  IA: 'Iowa',
  MD: 'Maryland',
  ND: 'North Dakota',
  NH: 'New Hampshire',
  NY: 'New York',
  VT: 'Vermont',
  KS: 'Kansas',
  MS: 'Mississippi',
  SC: 'South Carolina',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WY: 'Wyoming',
  NV: 'Nevada',
};

export const Popup = ({ type, handleAbort, data }) => {
  const className = useMemo(() => {
    let cn = 'smarty-popup-header';
    if (type === 1) {
      cn += ' smarty-popup-missing-input-header';
    }
    if (type === 2 || type === 3 || type === 4) {
      cn += ' smarty-popup-invalid-header';
    }
    return cn;
  }, [type]);
  return (
    <div className="smarty-ui">
      <div className="smarty-popup">
        <div className={className}>
          {type === 1 && "You didn't enter enough information"}
          {type === 2 && 'You entered an unknown address'}
          {type === 3 && 'P.O Box address is not allowed'}
          {type === 4
            && `Currently we do not accept loan applications for residents of the state of ${
              unSupportedStates[data.state]
            }`}
        </div>
        <div className="smarty-popup-typed-address">
          {type !== 4
            && `${data.address || ''} ${data.city || ''} ${data.state || ''} ${
              data.zipcode || ''
            }`}
        </div>
        <div
          className="smarty-choice-alt"
          style={{
            justifyContent:
              !appConfig.smartyStreetEnforce && type !== 1
                ? 'space-between'
                : 'center',
          }}
        >
          {type !== 1 && (
            <div
              className="smarty-choice smarty-choice-abort smarty-abort"
              onClick={handleAbort}
            >
              Use this address anyway
            </div>
          )}
          <div
            className="smarty-choice smarty-choice-abort smarty-abort"
            onClick={handleAbort}
          >
            Go back
          </div>
        </div>
      </div>
    </div>
  );
};

Popup.propTypes = {
  handleAbort: PropTypes.func.isRequired,
  type: PropTypes.number.isRequired,
  data: PropTypes.object,
};

Popup.defaultProps = {
  data: {},
};

const VerifyAddress = ({ isLoading, onClick, isVerified, className }) => {
  const [isHovered, setHovered] = useState(false);

  const classNameCommoon = 'tracking-[0.5px] md:tracking-[1px] rounded-[4px] font-normal p-[4px] pl-[8px] pr-[8px] md:p-[7px] md:pl-[15px] md:pr-[15px] border-[0px] text-[#FFF] text-[12px] md:text-[14px] text-center cursor-pointer hover:border-[#333] transition-all duration-200';
  const classNameSuccess = `${classNameCommoon} w-[100px] md:w-[120px] bg-[#00BC6D] hover:bg-[#009657] ${className}`;
  const classNamePrimary = `${classNameCommoon} w-[100px] md:w-[120px] bg-[#3989E3] hover:bg-[#1e75d7] ${className}`;

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };
  return isVerified ? (
    <div
      className={classNameSuccess}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      ✓&nbsp;&nbsp;
      <span className="w-full text-center">
        {isHovered ? 'UNDO' : 'VERIFIED'}
      </span>
    </div>
  ) : (
    <>
      {isLoading && (
        <div className="absolute text-left top-[46px] left-full ml-[-150px]">
          <img src={IMG_LOADING} alt="" />
        </div>
      )}
      <div className={classNamePrimary} onClick={onClick}>
        <span className="w-full text-center">VERIFY</span>
      </div>
    </>
  );
};

VerifyAddress.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isVerified: PropTypes.bool,
  className: PropTypes.string,
};

VerifyAddress.defaultProps = {
  isLoading: false,
  isVerified: false,
  className: '',
};

export default VerifyAddress;
